// Get the sidebar element
const sidebar = document.querySelector('.content-post__sidebar');
const threshold = document.documentElement.scrollHeight / 5;
let isFixed = false;
let ticking = false;

if (sidebar) {
  document.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollPos = window.scrollY;

          // Only make DOM changes when state changes.
          if (scrollPos < threshold && !isFixed) {
            sidebar.classList.add('content-post__sidebar--fixed');
            isFixed = true;
          } else if (scrollPos >= threshold && isFixed) {
            sidebar.classList.remove('content-post__sidebar--fixed');
            isFixed = false;
          }

          ticking = false;
        });

        ticking = true;
      }
    },
    { passive: true }, // Use passive event listener for better scroll performance.
  );
}
